<app-logo-header></app-logo-header>
<div class="main-container">
  <app-public-rounded-container>
    <form [formGroup]="mogoOption" [hidden]="!nextStep">
      <h4 class="card-title text-center">
        {{ "BUYER_INFO.Mogo.MogoOtions" | translate }}
      </h4>

      <h6 id="d-block" for="options">
        {{ "BUYER_INFO.Mogo.ChooseOption" | translate }}:
      </h6>
      <div
        *ngFor="let option of mogoInstallments; let i = index"
        [attr.data-index]="i"
      >
        <div
          class="custom-control custom-radio custom-control-inline form-check mb-2"
        >
          <input
            class="form-check-input"
            type="radio"
            [value]="option.planId"
            formControlName="option"
          />
          <label class="form-check-label d-block"
            >{{ option.months }} {{ "BUYER_INFO.Mogo.Months" | translate }} -
            {{ "BUYER_INFO.Mogo.MonthlyAmount" | translate }} :
            {{ option.installment }}</label
          >
        </div>
      </div>
      <div>
        <button
          mat-button
          class="btn btn-primary"
          (click)="sendOTP()"
          [disabled]="mogoOption.invalid"
        >
          {{ "BUYER_INFO.Mogo.Next" | translate }}
        </button>
        <div>{{ sendFailed }}</div>
      </div>
    </form>

    <form [formGroup]="mogoOtp" [hidden]="nextStep">
      <h4 class="card-title text-center">
        {{ "BUYER_INFO.Mogo.EnterOTP" | translate }}
      </h4>
      <mat-form-field>
        <mat-label>{{ "Sellers.Products.EnterOtp" | translate }}</mat-label>
        <input
          matInput
          type="text"
          placeholder="{{ 'Sellers.Products.EnterOtp' | translate }}"
          formControlName="otp"
          name="otp"
        />
      </mat-form-field>
      <div
        *ngIf="
          mogoOtp.controls.otp.invalid &&
          (mogoOtp.controls.otp.dirty || mogoOtp.controls.otp.touched)
        "
        class="text-danger"
      >
        <div *ngIf="mogoOtp.controls.otp.errors?.['required']">
          {{ "BUYER_INFO.Mogo.Required" | translate }}
        </div>
        <div *ngIf="mogoOtp.controls.otp.errors?.['pattern']">
          {{ "BUYER_INFO.Mogo.Pattern" | translate }}
        </div>
      </div>
      <div>
        <button
          mat-button
          [disabled]="mogoOtp.invalid"
          class="col-12 btn btn-primary my-2"
          (click)="payment()"
        >
          {{ "BUYER_INFO.Mogo.Payment" | translate }}
        </button>
        <button class="col-12 btn btn-success" (click)="resendOTP()">
          {{ "Sellers.Products.Resend" | translate }}
        </button>
        <div>{{ sendFailed }}</div>
      </div>
    </form>
  </app-public-rounded-container>
</div>
